import styled from 'styled-components';
const Container = styled.ul `
  background-color: var(--white);
  width: 100%;
`;
export default Container;
